module["exports"] = [
  "#{Name.last_name}#{street_suffix}"
];
